import { IModel, Model, ModelRecord } from '@common/models/Model';

export interface IProactivePrescriptionVeterinarianRuleItemModel
  extends IModel {
  proactivePrescriptionVeterinarianRuleItemId: number;
  proactivePrescriptionVeterinarianRuleId: number;
  salesItemOptionId: number;
  businessLineId: number;
}

export class ProactivePrescriptionVeterinarianRuleItemModel
  extends Model
  implements ModelRecord<IProactivePrescriptionVeterinarianRuleItemModel>
{
  proactivePrescriptionVeterinarianRuleItemId: number;
  proactivePrescriptionVeterinarianRuleId: number;
  salesItemOptionId: number;
  businessLineId: number;

  constructor(
    params?: Partial<IProactivePrescriptionVeterinarianRuleItemModel>,
  ) {
    super(params);
    this.proactivePrescriptionVeterinarianRuleItemId =
      params?.proactivePrescriptionVeterinarianRuleItemId || 0;
    this.proactivePrescriptionVeterinarianRuleId =
      params?.proactivePrescriptionVeterinarianRuleId || 0;
    this.salesItemOptionId = params?.salesItemOptionId || 0;
    this.businessLineId = params?.businessLineId || 0;
  }
}
